import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import Script from 'next/script';
import { useRef } from 'react';

const DynamicYieldScript = ({ sectionId, onScriptsLoad, }) => {
    const scriptLoadedCountRef = useRef(2);
    const onDynamicYieldScriptLoad = () => {
        const scriptLoadedCount = scriptLoadedCountRef.current - 1;
        const hasLoadingScript = scriptLoadedCount > 0;
        scriptLoadedCountRef.current = hasLoadingScript ? scriptLoadedCount : 0;
        if (hasLoadingScript) {
            return;
        }
        onScriptsLoad?.();
    };
    return (jsxs(Fragment, { children: [jsx(Script, { src: `https://cdn.dynamicyield.com/api/${sectionId}/api_static.js`, strategy: "afterInteractive", onLoad: onDynamicYieldScriptLoad }), jsx(Script, { src: `https://cdn.dynamicyield.com/api/${sectionId}/api_dynamic.js`, strategy: "afterInteractive", onLoad: onDynamicYieldScriptLoad })] }));
};

export { DynamicYieldScript as D };
//# sourceMappingURL=component-BcgmQevS.js.map
